<template>
    <div :class="[
        'z-radio',
        `z-radio--size-${size}`,
        { 'is-error': error },
        { 'is-disabled': disabled }
    ]">
        <div class="z-radio__list">
            <div
                class="z-radio__item"
                v-for="(item, index) in data"
                :key="index"
            >
                <label class="z-radio__label">
                    <input
                        class="z-radio__input"
                        type="radio"
                        :name="name"
                        :value="item.value"
                        v-model="radioValue"
                        @change="onChange"
                    >
                    <span class="z-radio__circle"></span>
                    <span class="z-radio__text" v-html="item.text"></span>
                </label>
            </div>
        </div>
        <span
            :class="['z-radio__error', errorClass]"
            v-if="error"
            v-html="error"
        ></span>
    </div>
</template>

<script>
export default {
    name: 'z-radio',
    props: {
        modelValue: String,
        data: {
            type: Array,
            default: () => [],
            required: true
        },
        size: {
            type: String,
            default: 'm',
            validator: prop => ['s', 'm', 'l'].includes(prop)
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        errorClass: {
            type: String,
            default: ''
        },
        disabled: Boolean
    },
    data () {
        return {
            localValue: this.modelValue,
            error: '',
            text: {
                error: {
                    en: 'Required field',
                    cn: '必必填字段'
                }
            }
        }
    },
    computed: {
        radioValue: {
            get () {
                if (typeof this.modelValue !== 'undefined') return this.modelValue
                return this.localValue
            },
            set (value) {
                this.$emit('input', value)
                this.localValue = value
                this.$emit('update:modelValue', value)
            }
        }
    },
    methods: {
        onChange () {
            this.$nextTick(this.validate)
            this.$emit('change', this.localValue)
            this.$emit('update:modelValue', this.localValue)
        },
        validate () {
            if (this.required && !this.radioValue) {
                this.error = this.$root.localize(this.text.error)
            } else {
                this.error = ''
            }
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
